import React, { useState } from 'react';
import Spinner from '../Components/Spiner/Spinner'; // Asegúrate de ajustar la ruta
import Topbar from '../Components/Topbar/TopBar';
import Navbar from '../Components/Navbar/Navbar';
import Footer from '../Components/Footer/Footer';
import ServiceStart from '../Components/ServiceStart/ServiceStart';

const Service = () => {
  const [isLoading, setIsLoading] = useState(true);

  // Simula la carga con un temporizador
  React.useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <Topbar />
      <Navbar />
      <Spinner isLoading={isLoading} />
      {!isLoading && (
        <>
          <ServiceStart/>
          <Footer />
        </>
      )}
    </div>
  );
};

export default Service;
